module.exports = __webpack_public_path__ + "static/img/icon_por-den.92d06979.svg";